module.exports = __webpack_public_path__ + "hyperion-v2-static/img/driver_economic_circle.ffa42e84.png";